import React from 'react';
import {Meta, MetaCount, Title, EntityBarCont, RateDiv} from "../styles/entity_sel_styles.js"
import {Rating} from '@material-ui/lab';

const EntityBar = (props, onEntitySelect, ndx) => {

  let total_score = props.descriptors.score
  let review_score = total_score/20

  return(
    <EntityBarCont title = {props.title}  onClick = { () => props.onEntitySelect(props) }>
      <Title title={props.title}>
        {props.descriptors.name}
      </Title>
      <Meta title={props.title}>
        <RateDiv>
          <Rating name="half-rating-read" value={review_score} precision={0.5} size="small" readOnly />
        </RateDiv>
        <MetaCount> {props.descriptors.num_review} reviews </MetaCount>
      </Meta>
    </EntityBarCont>
  )

}

export default EntityBar;
